export default __webpack_public_path__ + "static/media/index.ce56dc52.png";